import { uploadFile, type UploadContext } from '@/lib/upload-file';

// Uploads an image to S3 via the GET /uploads/presign flow and returns the
// permanent S3 key to store on the record's `image_url`.
//
// Regression: GitHub issue #123 — on the New Product wizard's Images step the
// selected file was only held in local state and a "Upload will be connected to
// S3" toast was shown; no upload ever happened. A first fix added this helper
// but read `url`/`key` off the raw response body — the API wraps every response
// in a `{ statusCode, data }` envelope (ResponseInterceptor), so both came back
// undefined and the PUT went nowhere. It also let the presign default to
// image/jpeg while PUTting the file's real MIME type, which breaks the S3
// signature for PNG/WebP. This unwraps the envelope, forwards the real content
// type, and fails loudly when the presign response is malformed.

export async function uploadImageViaPresign(
  file: File,
  type: string,
  fetchImpl: typeof fetch = fetch,
): Promise<string> {
  // `type` used to be the presign endpoint's upload-type; it maps 1:1 onto the
  // new upload context. `category_image` is the one spelling that differed.
  const context = type === 'category_image' ? 'category-image' : type;
  const { key } = await uploadFile(file, context as UploadContext, fetchImpl);
  return key;
}

export function uploadProductImage(
  file: File,
  fetchImpl: typeof fetch = fetch,
): Promise<string> {
  return uploadImageViaPresign(file, 'product-image', fetchImpl);
}
